import { Request as request } from "@/utils/request"
/**
 * 提交反馈
 * @param {
 * content,
 * email
 * } params 
 * @returns 
 */
let submitFeedback = (params) => {
    return request("/api/common/feedback", {
        method: "POST",
        params
    })
}
export {
    submitFeedback
}